import React, {useEffect} from "react";
import {Box, Container, Grid} from "@mui/material";
import {MainAppBar} from "~/ui/AppBar/MainAppBar";
import {CatalogGrid} from "~/catalog/components/CatalogGrid";
import {InstallPrompt} from "~/components/InstallPrompt";
import {CurrentReleaseVersion} from "~/release-notes/components/CurrentReleaseVersion";
import {
    ForbiddenAndUnavailableServiceErrorHandlerProvider
} from "~/components/ErrorHandling/ForbiddenAndUnavailableServiceErrorHandlerProvider";
import {useHistory, useLocation} from "react-router-dom";


const IndexPage = () => {
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        if (location.search != "") {
            return;
        }
        // если мы на главной нажимаем выход, то нужно выйти
        const handleExit = (...args) => {
            for (let i = 0; i < history.length; ++i) {
                history.goBack();
            }
        }

        window.addEventListener("popstate", handleExit);
        return () => window.removeEventListener("popstate", handleExit)
    }, [location]);


    const appBar = (
        <MainAppBar/>
    )

    return (
        <>
            <ForbiddenAndUnavailableServiceErrorHandlerProvider
                appBar={appBar}
            >
                {appBar}
                <Box height="56px"/>
                <Container>
                    <Box padding="16px 0">
                        <CatalogGrid/>
                    </Box>
                </Container>
                <Box position="fixed" bottom={0} left={0} right={0}>
                    <InstallPrompt/>
                    <Grid container padding="8px" justifyContent="center">
                        <CurrentReleaseVersion/>
                    </Grid>
                </Box>
            </ForbiddenAndUnavailableServiceErrorHandlerProvider>
        </>
    );
}


export default IndexPage;